import { PlacementSession } from "../tutor-reports/placement-session.model";
import { PlacementStudentV2 } from "../tutor-reports/tutorreport";

export class SearchPlacementResult {
    bookingId: string;
    clientName: string;
    clientId: string;
    session: string;
    yearGroup: string;
    startDate?: Date;
    endDate?: Date;
    studentDescription: string;
    placementReferrer?: number;
    placementCustodian?: number;
    type: string;
    groupSize: number;
    maxGroupSize: number;
    isGroup: boolean;
    // Orbit OPC DeliveryMode ('Online'/'In person') - raw string, compare case-insensitively.
    deliveryMode: string;
    // Orbit provision type code ('AP'/'SP') - compare case-insensitively.
    provisionTypeCode?: string;
    dotFlag: number; 
    jobId: Number;
    studentNameList: string;
    tutorName: string;
    placementSessions: PlacementSession[];
    sessionCalendar: SessionMonth[];
    students: PlacementStudentV2[];

    showSessionSlider: boolean = false;
    showInfo: boolean = true;

    constructor() {}
}

export class SessionMonth {
    title: string;
    subTitle: string;
    sessionWeeks: SessionWeek[];
    isFuture: boolean;
    displayOrder: number;

    constructor() {}
}

export class SessionWeek {
    title: string;
    subTitle: string;
    highlight: boolean;
    sessions: PlacementSession[];
    isFuture: boolean;
    displayOrder: number;

    constructor() {}
}